import { Heading, Paragraph, Popover } from '@zillow/constellation-10';

type Props = {
  bodyContent: string;
};

const InfoPopover = ({ bodyContent }: Props) => {
  return (
    <Popover
      header={<Heading level={6}>Fee level</Heading>}
      body={<Paragraph>{bodyContent}</Paragraph>}
      trigger={<Popover.Trigger css={{ marginLeft: '200' }} />}
    />
  );
};

export default InfoPopover;
